<template>
  <div class="box_row warp">
    <div class="role-item" v-for="(item, index) in roleList" :key="index">
      <div class="box_row header">
        <div class="header-img">
          <img v-if="!item.create" src="@/assets/img/manage.png" alt="" />
          <img v-else src="@/assets/img/add.png" alt="" />
        </div>
        <span class="edit" @click="editRole">编辑权限</span>
      </div>
      <div>{{ item.role }}</div>
      <div class="info">
        <div>{{ item.info }}</div>
        <div>
          该角色目前已配置 <span style="color:#FF5F5F;">{{ item.num }}</span> 个账号。
        </div>
      </div>
      <el-button class="manage-btn" @click="item.create ? addRole() : editMember()">{{
        item.create ? '新增角色' : '管理成员'
      }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    addRole: 'add',
    editMember: 'edit',
    editRole: 'role',
  },
  data() {
    return {
      roleList: [
        {
          role: '管理员',
          info: '管理员具有平台全部功能使用权限，请谨慎配置。',
          num: 2,
        },
        {
          role: '管理员',
          info: '管理员具有平台全部功能使用权限，请谨慎配置。',
          num: 2,
        },
        {
          role: '管理员',
          info: '管理员具有平台全部功能使用权限，请谨慎配置。',
          num: 2,
        },
        {
          role: '管理员',
          info: '管理员具有平台全部功能使用权限，请谨慎配置。',
          num: 2,
        },
        {
          role: '管理员',
          info: '管理员具有平台全部功能使用权限，请谨慎配置。',
          num: 2,
        },
        {
          role: '自定义',
          info: '配置自定义角色，并在该角色下配置员工账号。',
          num: 2,
          create: true,
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.warp {
  flex-wrap: wrap;
}
.role-item {
  .flex_layout(column, space-between);
  width: 240px;
  height: 287px;
  background: @bg-white;
  margin: 0 20px 20px 30px;
  padding: 20px 20px 33px;
}
.header {
  width: 100%;
  justify-content: flex-end;
  .edit {
    padding-left: 20px;
    color: #4359b7;
    cursor: pointer;
  }
}
.header-img {
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border-radius: 50%;
  img {
    margin: 20px 22px;
  }
}
.info {
  padding: 0 15px;
  line-height: 20px;
}
.manage-btn {
  padding: 10px 22px;
  color: #fff;
  font-weight: 400;
  line-height: 20px;
  background: @primary-blue;
  border-color: @primary-blue;
}
</style>
